/* Reorganize existing header links without changing their URLs or visible labels. */
(function () {
  function buildHeader() {
    var header = document.querySelector('.site-header');
    var nav = document.getElementById('SiteNav');
    if (!header || !nav || nav.dataset.vinicaReady) return;

    var items = Array.prototype.slice.call(nav.children);
    if (items.length < 10) return;

    var services = items[1];
    var menu = document.createElement('ul');
    menu.className = 'vinica-services-menu';
    menu.id = 'vinica-services-menu';

    items.slice(2, 8).forEach(function (item) { menu.appendChild(item); });
    services.classList.add('vinica-services');
    services.appendChild(menu);

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'vinica-services-toggle';
    toggle.setAttribute('aria-label', 'Show All services menu');
    toggle.setAttribute('aria-controls', menu.id);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<span aria-hidden="true">⌄</span>';
    services.insertBefore(toggle, menu);

    function close() {
      services.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
    toggle.addEventListener('click', function () {
      var open = services.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', function (event) {
      if (!services.contains(event.target)) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
    services.addEventListener('focusout', function (event) {
      if (!services.contains(event.relatedTarget)) close();
    });

    nav.dataset.vinicaReady = 'true';
    moveLanguageSwitcher();
  }

  function moveLanguageSwitcher() {
    var wrapper = document.querySelector('.gt_switcher_wrapper');
    var icons = document.querySelector('.site-header__icons-wrapper');
    if (!wrapper || !icons || icons.contains(wrapper)) return;
    icons.insertBefore(wrapper, icons.firstChild);
    wrapper.classList.add('vinica-language-switcher');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildHeader, { once: true });
  } else {
    buildHeader();
  }

  /* GTranslate adds its widget after the page is ready. */
  var observer = new MutationObserver(function () {
    var wrapper = document.querySelector('.gt_switcher_wrapper');
    var icons = document.querySelector('.site-header__icons-wrapper');
    if (wrapper && icons && !icons.contains(wrapper)) moveLanguageSwitcher();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
